import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  label: string;
  value: string;
}

export const WaitingField = ({ label, value }: Props) => (
  <Flex flexDir="column" gap="4px">
    <Text fontWeight={600} fontSize="13px" color={AppColors.GRAY_TEXT}>
      {label}
    </Text>
    <Flex
      border="1px solid"
      borderColor="gray.200"
      borderRadius="6px"
      paddingX="12px"
      paddingY="8px"
      bg="gray.50"
      minH="40px"
      alignItems="center"
    >
      <Text
        fontSize="14px"
        color={value === "Esperando datos" ? AppColors.LIGHT_GRAY_TEXT : undefined}
      >
        {value}
      </Text>
    </Flex>
  </Flex>
);
